/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/EndpointFooterComponent" />
import React = require("react");
import { VssComponent } from "VSS/Platform/Layout";
import { EndpointLoadingSpinner } from "./EndpointLoadingSpinner";

export interface IEndpointFooterComponentProps {
    renderButtons?: () => JSX.Element;
}

interface IEndpointFooterComponentPropsInternal extends IEndpointFooterComponentProps {
    renderLinks?: () => JSX.Element;
}

export class EndpointFooterComponent extends VssComponent<IEndpointFooterComponentPropsInternal> {

    public render(): JSX.Element {
        return (<div className="connections-editor-panel-footer">
            {this.props.renderLinks && this.props.renderLinks()}

            <div className="connections-editor-panel-footer-right">
                <EndpointLoadingSpinner>
                    {this.props.renderButtons && this.props.renderButtons()}
                </EndpointLoadingSpinner>
            </div>
        </div>);
    }
}
